<script>
import baseMixin from '@/mixins/baseMixin'
import markdownToHtmlConverter from '@/utils/markdown-to-html-converter.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BookingCreateRestrictedAlert',
  mixins: [baseMixin],
  props: {
    locationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getRestrictionDetailsByLocationId:
        'locations/getRestrictionDetailsByLocationId',
    }),
    restriction() {
      return this.getRestrictionDetailsByLocationId(this.locationId)
    },
  },
  mounted() {
    this.getMessage()
  },
  methods: {
    getMessage() {
      const htmlMessage = markdownToHtmlConverter(
        this.restriction.messageMarkDown
      )

      // Inject status html into body content
      document
        .getElementById('create-booking-restriction__message')
        .insertAdjacentHTML('afterbegin', htmlMessage)
    },
  },
}
</script>

<template>
  <v-alert class="create-booking-restriction-alert" text prominent type="info">
    <div id="create-booking-restriction__message"></div>
  </v-alert>
</template>

<style lang="scss">
#create-booking-restriction__message {
  > p {
    margin-bottom: 0 !important;
  }
}
</style>
